export default __webpack_public_path__ + "static/media/Asirgarh-Fort.a2f7408e.jpg";